import React from 'react'
import * as S from './styles'
import colors from '@/main/style/colors'

interface IColumLabelProps {
  label: string | React.ReactNode
  content: string | React.ReactNode
  propsLabel?: React.HTMLAttributes<HTMLParagraphElement>
  propsContent?: React.HTMLAttributes<HTMLParagraphElement>
  withColon?: boolean
  idContainer?: string
  onClick?: () => void
}

function ColumnLabel({
  label,
  content,
  propsLabel,
  propsContent,
  withColon = false,
  idContainer,
  onClick
}: IColumLabelProps) {

  const isString = (value: string | React.ReactNode): value is string => typeof value === 'string';
  return (
    <S.Container id={idContainer}>
      <S.LabelArea>{isString(label) ? <S.LabelText {...propsLabel}>{label}{withColon ? ':' : ''}</S.LabelText> : <>{label}{withColon ? ':' : ''}</>}</S.LabelArea>
      <S.ContentArea
        onClick={onClick}
        style={onClick ? { color: colors.pantone2727C, textDecoration: 'underline' } : {}}
      >
        {isString(content) ? <S.ContentText title={content} {...propsContent}>{content}</S.ContentText> : content}
      </S.ContentArea>
    </S.Container>
  )
}

export default ColumnLabel